class imagesRegister {

    static images = [];
    static main = null;

    static set(value){
        imagesRegister.images = value;
        try {
            sessionStorage.setItem('flow-images', JSON.stringify(imagesRegister.images));
        }catch (e) {
            console.log(e);
        }
    }

    static setMain(value){
        imagesRegister.main = value;
        try {
            sessionStorage.setItem('flow-image-main', JSON.stringify(value));
        }catch (e) {}
    }

    static get(){
        try {
            if(Array.isArray(imagesRegister.images) && imagesRegister.images.length > 0){
                return imagesRegister.images;
            }else{
                if(sessionStorage.getItem('flow-images')){
                    return JSON.parse(sessionStorage.getItem('flow-images'));
                }else{
                    return imagesRegister.images;
                }
            }
        }catch (e) {
            return imagesRegister.images;
        }
    }

    static getMain(){
        try {
            if(sessionStorage.getItem('flow-image-main')){
                return JSON.parse(sessionStorage.getItem('flow-image-main'));
            }else{
                return imagesRegister.main;
            }
        }catch (e) {
            return imagesRegister.main;
        }
    }

    static remove(){
        try {
            sessionStorage.removeItem('flow-images');
            sessionStorage.removeItem('flow-image-main');
        }catch (e) {}
        imagesRegister.images = [];
        imagesRegister.main = null;
    }

}

export {imagesRegister}


// WEBPACK FOOTER //
// ./src/services/imagesRegister.js